<template>
  <div>
    <div class="fixed-area">
        <div class="area" @click="back">
          <van-icon name="arrow-left" />
        </div>
        <div>
          {{title}}
        </div>
      </div>
      <div class="palace-holder">

      </div>
  </div>
</template>

<script>
import {Icon} from 'vant';
  export default {
    props : ["title"],
    components : {
        [Icon.name]:Icon
    },
    methods : {
      back() {
        this.$router.go(-1)
      }
    }
  }
</script>

<style scoped>
.fixed-area{
  background : #fff;
  position : fixed;
  top : 0 ;
  left : 0;
  width : 100%;
  height : 48px;
  z-index : 999;
  text-align : center;
  line-height : 48px;
}
.palace-holder{
  height : 48px;
}
.area{
  position : fixed;
  top : 0 ;
  left : 0;
  padding-left : 20px;
  width : 50px;
  height : 48px;
  z-index : 99;
  display : flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/backheader.vue